module.exports = __webpack_public_path__ + "81cfb7a1214afab0a3f94ae37289d4a9.docx"


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/app/helpers/downloadClipping/template.docx
 ** module id = 1696
 ** module chunks = 0
 **/